export default __webpack_public_path__ + "static/media/Guideline.9b9c2a78.svg";